/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complementary for bold contrast, analogous for a calm palette, triadic or tetradic for vibrant balance, and monochromatic for a subtle single-hue scheme.`)
};

const es_cp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complementaria para un contraste llamativo, análoga para una paleta tranquila, triádica o tetrádica para un equilibrio vibrante, y monocromática para un esquema sutil de un solo tono.`)
};

const de_cp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komplementär für starken Kontrast, analog für eine ruhige Palette, triadisch oder tetradisch für ein lebendiges Gleichgewicht und monochromatisch für ein dezentes Einfarbschema.`)
};

const nl_cp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complementair voor een sterk contrast, analoog voor een rustig palet, triadisch of tetradisch voor levendige balans, en monochroom voor een subtiel palet in één tint.`)
};

const fr_cp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complémentaire pour un contraste marqué, analogue pour une palette apaisante, triadique ou tétradique pour un équilibre vibrant, et monochromatique pour un schéma subtil à teinte unique.`)
};

const it_cp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complementare per un contrasto deciso, analoga per una palette calma, triadica o tetradica per un equilibrio vivace, e monocromatica per uno schema sottile su un'unica tonalità.`)
};

const pt_br2_cp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complementar para contraste ousado, análoga para uma paleta tranquila, tríade ou tétrade para equilíbrio vibrante, e monocromática para um esquema sutil de tom único.`)
};

const pt_cp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complementar para um contraste forte, análoga para uma paleta calma, triádica ou tetrádica para um equilíbrio vibrante, e monocromática para um esquema subtil de um único tom.`)
};

const ja_cp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`強いコントラストには補色、落ち着いた配色には類似色、鮮やかなバランスにはトライアドやテトラード、控えめな単色系にはモノクロマティックが適しています。`)
};

const zh_cp_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`互补色适合强烈对比，邻近色适合营造平和的配色，三分色或四分色适合鲜明的平衡感，同色系适合低调的单色调方案。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_faq_a2", locale)
	if (locale === "en") return en_cp_faq_a2(inputs)
	if (locale === "es") return es_cp_faq_a2(inputs)
	if (locale === "de") return de_cp_faq_a2(inputs)
	if (locale === "nl") return nl_cp_faq_a2(inputs)
	if (locale === "fr") return fr_cp_faq_a2(inputs)
	if (locale === "it") return it_cp_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_cp_faq_a2(inputs)
	if (locale === "pt") return pt_cp_faq_a2(inputs)
	if (locale === "ja") return ja_cp_faq_a2(inputs)
	return zh_cp_faq_a2(inputs)
};